import { AlertDialog, Button, HStack, Text } from 'native-base'
import * as React from 'react'
import Colors from '../Constants/Colors'

interface PopupMessageProps {
  ref?: React.RefObject<any>
  isOpen: boolean
  onClose: () => void
  message: string
}

const PopupMessage = ({ ref, isOpen, onClose, message }: PopupMessageProps) => {
  if (!ref) ref = React.useRef(null)

  return (
    <AlertDialog isOpen={isOpen} onClose={onClose} leastDestructiveRef={ref}>
      <AlertDialog.Content>
        <AlertDialog.Body
          style={{
            justifyContent: 'center',
            // backgroundColor: Colors.redError,
            alignItems: 'center',
          }}
        >
          {message}
        </AlertDialog.Body>
        <HStack>
          <Button
            style={{
              backgroundColor: Colors.primaryColor,
            }}
            onPress={() => onClose()}
            width="100%"
          >
            <Text color="black" fontSize={12}>
              OK
            </Text>
          </Button>
        </HStack>
      </AlertDialog.Content>
    </AlertDialog>
  )
}

export default PopupMessage
